require('./baseState.js');

/*
 * Be careful adding any events that have global state side-effects
 * as actions on this state.  Transitions away from the editor could
 * become problematic.
* */

PegasusTemplate.EditingSavingState = PegasusTemplate.BaseState.extend({
  edit: Ember.K,

  setup: function(manager, callback){
    PegasusTemplate.set('status', 'saving');
    if( callback ){
      callback();
      return;
    }
  },

  success: function(){
    Ember.run.next( PegasusTemplate.stateMachine, 'transitionTo', 'saved' );
  },

  exit: function(){
    PegasusTemplate.set('status', 'editing');
  },

  error: function(){
    Ember.run.next( PegasusTemplate.stateMachine, 'transitionTo', PegasusTemplate.stateMachine.get( 'currentState.parentState.path' ) );
  }
});

PegasusTemplate.EditingSubState = PegasusTemplate.BaseState.extend({
  isEditing: true,

  hideControls: function(){
    PegasusTemplate.lookupController('blockOperations').set('content', null );
    PegasusTemplate.lookupController('rowOperations').set('content', null );
  },
  didSave: function(manager){
    var editingController = PegasusTemplate.lookupController('editing'),
      toolbarController = PegasusTemplate.lookupController('toolbar'),
      edited = editingController.get('edited.payload'),
      backup,
      sourceElement;

    backup = this.get('entryValue');
    sourceElement = editingController.get('row').mutateForOut(null, true).editor_cookie;

    var command = PegasusTemplate.EditBlockCommand.create({
      klass: edited.get('parentView.row').constructor,
      backup: backup,
      sourceElement: sourceElement,
      childPosition: edited.get('parentView.row.parentView').indexOf( edited.get('parentView.row') )
    });

    command.execute();

    manager.send('didSaveFragment');
  },

  setup: function( manager, context, types ){
    this._super.apply(this, arguments);

    if ( !context.get('isUserVisible') ) {
      context.set('payload.dataIsDisplayed', 'true');
      // Trigger change to show/hide hidden
      $(window).trigger('didToggleImageDisplayMode');
    }

    this.set('entryValue', context.get('row').mutateForOut(null,true).editor_cookie);
    this.set('editedBlockIndex', context.get('row.blocks').indexOf( context ));

    PegasusTemplate.lookupController('toolbar').set('touched', false);

    var block = context,
      payload = block.get('payload'),
      controller = PegasusTemplate.lookupController('editing');

    controller.setProperties({
      content: payload,
      edited: context
    });

    Em.run.sync();
    PegasusTemplate.lookupController('frameCommManager').send('editBlock', context.get('toolbarProperties') );
  },

  changePalette: function(manager, view){
    manager.send('edit', view);
  },

  didFinishEditing: function(manager){
    PegasusTemplate.Helpers.addOneTimeObserver( manager, 'currentPath', 'saved', function(){
      Ember.run.scheduleOnce( 'afterRender', manager, 'transitionTo', 'idling' );
    });

    manager.send('didSave');
  },

  hover: function(manager, context){
    if ( PegasusTemplate.lookupController('editing').get('edited') !== context.view ){
      PegasusTemplate.lookupController('blockOperations').set('content', context.view);
    } else {
      // the ordering is important here
      PegasusTemplate.lookupController('blockOperations').set('content', null );
      PegasusTemplate.lookupController('rowOperations').set('content', context.view.get('row') );
    }
  },

  edit: function(manager, context){
    var entryIndex,
      newRow,
      newRowIndex,
      blockCount = context.get('row.blocks.length'),
      type = context.get('payload.type').camelize(),
      transitionedCallback = function(){
        manager.transitionTo('editing.' + type, context );
      };

    if ( context.get('row') ) {
      entryIndex = context.get('row.blocks').indexOf( context );
      newRow = context.get('row');
      newRowIndex = PegasusTemplate.blockRegionInstance.indexOf( newRow );
      transitionedCallback = function(){
        var targetRow = PegasusTemplate.blockRegionInstance.objectAt( newRowIndex );
        if ( targetRow.get('blocks.length') === blockCount ) {
          Em.run.scheduleOnce('afterRender', manager, function(){
            this.transitionTo( 'editing.' + type, targetRow.get('blocks').objectAt(entryIndex) );
          });
          return;
        }
        Em.run.next( this, transitionedCallback );
      };
    }

    PegasusTemplate.Helpers.addOneTimeObserver(manager, 'currentPath', 'saved', transitionedCallback.bind(this) );

    manager.send('didSave');
  },

  didSaveFragment: function(manager, fragment){
    manager.transitionTo('saved');
  },
  saving: PegasusTemplate.EditingSavingState
});

PegasusTemplate.EditingPaletteState = PegasusTemplate.BaseState.extend({
  screen: null,

  hover: function(manager, context){
    if ( PegasusTemplate.lookupController('editing').get('edited') !== context.view ){
      PegasusTemplate.lookupController('blockOperations').set('content', context.view);
    } else {
      // the ordering is important here
      PegasusTemplate.lookupController('blockOperations').set('content', null );
      PegasusTemplate.lookupController('rowOperations').set('content', context.view.get('row') );
    }
  },

  edit: function(manager, context){
    var entryValue,
      entryIndex,
      newRow,
      newRowIndex,
      blockCount = context.get('row.blocks.length'),
      type = context.get('payload.type').camelize(),
      transitionedCallback = function(){
        manager.transitionTo('editing.' + type, context );
      };

    if ( context.get('row') ) {
      entryValue = this.get('entryValue');
      entryIndex = context.get('row.blocks').indexOf( context );
      newRow = context.get('row');
      newRowIndex = PegasusTemplate.blockRegionInstance.indexOf( newRow );
      transitionedCallback = function(){
        var targetRow = PegasusTemplate.blockRegionInstance.objectAt( newRowIndex );
        if ( targetRow.get('blocks.length') === blockCount ) {
          Em.run.scheduleOnce('afterRender', manager, function(){
            this.transitionTo( 'editing.' + type, targetRow.get('blocks').objectAt(entryIndex) );
          });
          return;
        }
        Em.run.next( this, transitionedCallback );
      };
    }

    PegasusTemplate.Helpers.addOneTimeObserver(manager, 'currentPath', 'saved', transitionedCallback.bind(this) );

    manager.send('didSave');
  },

  isEditing: true,

  command: null,

  hideControls: function(){
    PegasusTemplate.lookupController('blockOperations').set('content', null );
    PegasusTemplate.lookupController('rowOperations').set('content', null );
  },

  didSave: function(manager){
    manager.transitionTo('saved');
  },

  exit: function(){
    var command = this.get('command');
    if ( PegasusTemplate.lookupController('toolbar').get('touched') ) {
      command.create({
        sourceElement: PegasusTemplate.loadedTemplate().generateOutput(false).editor_cookie
      }).execute(true);
    }
    this.set('command', null);
  },

  setup: function( manager, context, types ){
    this._super.apply(this, arguments);

    this.set('entryValue', {});

    var command = PegasusTemplate.GlobalManipulationCommand.extend({
      backup: PegasusTemplate.loadedTemplate().generateOutput(false).editor_cookie,
      description: function(){
        return Em.I18n.t( 'command_descriptions.changed_page_style' );
      }.property()
    });

    this.set('command', command);

    PegasusTemplate.lookupController('frameCommManager').send('editPalette' );
  },

  changePalette: function(manager, view){
    manager.send('edit', view);
  },

  didFinishEditing: function(manager){
    PegasusTemplate.Helpers.addOneTimeObserver( manager, 'currentPath', 'saved', function(){
      Ember.run.scheduleOnce( 'afterRender', manager, 'transitionTo', 'idling' );
    });

    manager.send('didSave');
  },

  didSaveFragment: function(manager, fragment){
    manager.transitionTo('saved');
  },
  saving: PegasusTemplate.EditingSavingState
});

PegasusTemplate.EditingCapturePaletteState = PegasusTemplate.EditingPaletteState.extend({
  clickInterceptor: null,

  setup: function(manager, context) {
    PegasusTemplate.lookupController('template').set('isEditingCapturePalette', true);

    clickInterceptor = $('<div class="editing-palette-overlay" />');
    this.set('clickInterceptor', clickInterceptor);

    clickInterceptor.appendTo( $('.center-wrapper-container') );
    clickInterceptor.on('click', function(){
      Em.run( manager, 'send', 'didFinishEditing');
    });
  },

  exit: function(){
    this.get('clickInterceptor').remove();
    this.set('clickInterceptor', null);
    PegasusTemplate.lookupController('toolbar').set('panelMode', 'Edit');
    PegasusTemplate.lookupController('template').set('isEditingCapturePalette', false);
    this._super.apply(this, arguments);
  },

  didSave: function(manager, context){
    manager.send('didSaveFragment');
  }
});

PegasusTemplate.EditingSocialShareState = PegasusTemplate.EditingSubState.extend({
});

PegasusTemplate.EditingWebTemplateFooterState = Em.State.extend({
  isEditing: true,
  unexecuteSettings: {},
  didFinishEditing: function(manager){
    var toolbarController = PegasusTemplate.lookupController('toolbar');

    var command = PegasusTemplate.EditFooterCommand.create({
      unexecuteSettings: this.get('unexecuteSettings'),
      executeSettings: {
        isFooterLogoEnabled: toolbarController.get('isFooterLogoEnabled')
      }
    });

    command.execute();

    PegasusTemplate.Helpers.addOneTimeObserver( manager, 'currentPath', 'saved', function(){
      Ember.run.scheduleOnce( 'afterRender', manager, 'transitionTo', 'idling' );
    });

    manager.send('didSave');
  },

  setup: function( manager, context, types ){
    var toolbarController = PegasusTemplate.lookupController('toolbar');
    this._super.apply(this, arguments);

    this.set('unexecuteSettings', {
      isFooterLogoEnabled: toolbarController.get('isFooterLogoEnabled')
    });

    var block = context,
      payload = block.get('payload'),
      controller = PegasusTemplate.lookupController('editing');

    controller.setProperties({
      content: payload,
      edited: context
    });

    Em.run.sync();
    PegasusTemplate.lookupController('frameCommManager').send('editBlock', context.get('toolbarProperties') );
  },
  hover: function(manager, context){
    if ( PegasusTemplate.lookupController('editing').get('edited') !== context.view ){
      PegasusTemplate.lookupController('blockOperations').set('content', context.view);
    } else {
      // the ordering is important here
      PegasusTemplate.lookupController('blockOperations').set('content', null );
      PegasusTemplate.lookupController('rowOperations').set('content', context.view.get('row') );
    }
  },

  edit: function(manager, context){
    var entryValue,
      entryIndex,
      newRow,
      newRowIndex,
      blockCount = context.get('row.blocks.length'),
      type = context.get('payload.type').camelize(),
      transitionedCallback = function(){
        manager.transitionTo('editing.' + type, context );
      };

    if ( context.get('row') ) {
      entryValue = this.get('entryValue');
      entryIndex = context.get('row.blocks').indexOf( context );
      newRow = context.get('row');
      newRowIndex = PegasusTemplate.blockRegionInstance.indexOf( newRow );
      transitionedCallback = function(){
        var targetRow = PegasusTemplate.blockRegionInstance.objectAt( newRowIndex );
        if ( targetRow.get('blocks.length') === blockCount ) {
          Em.run.scheduleOnce('afterRender', manager, function(){
            this.transitionTo( 'editing.' + type, targetRow.get('blocks').objectAt(entryIndex) );
          });
          return;
        }
        Em.run.next( this, transitionedCallback );
      };
    }

    PegasusTemplate.Helpers.addOneTimeObserver(manager, 'currentPath', 'saved', transitionedCallback.bind(this) );

    manager.send('didSave');
  }
});

PegasusTemplate.EditingCaptureTemplateFooterState = PegasusTemplate.EditingWebTemplateFooterState.extend();

PegasusTemplate.EditingFooterState = Em.State.extend({
  isEditing: true,
  unexecuteSettings: {},

  executeCommand: function(){
    var toolbarController = PegasusTemplate.lookupController('toolbar');

    var command = PegasusTemplate.EditFooterCommand.create({
      unexecuteSettings: this.get('unexecuteSettings'),
      executeSettings: {
        isFooterEmailPreferencesEnabled: toolbarController.get('isFooterEmailPreferencesEnabled'),
        isFooterLogoEnabled: toolbarController.get('isFooterLogoEnabled'),
        footerLabelOpen: $('#unsubscribe_open').text(),
        footerLabelJoin: $('#unsubscribe_join').text(),
        footerLabelClose: $('#unsubscribe_close').text(),
        footerLabelColor: toolbarController.get('footerLabelColor'),
        footerLabelSize: toolbarController.get('footerLabelSize'),
        footerLabelAlignment: toolbarController.get('footerLabelAlignment'),
        footerLabelBold: toolbarController.get('footerLabelBold'),
        footerLabelItalic: toolbarController.get('footerLabelItalic'),
        footerCompany: toolbarController.get('footerCompany'),
        footerStreetAddress: toolbarController.get('footerStreetAddress'),
        footerLocality: toolbarController.get('footerLocality'),
        footerRegion: toolbarController.get('footerRegion'),
        footerPostalCode: toolbarController.get('footerPostalCode'),
        footerPhone: toolbarController.get('footerPhone'),
        footerCountry: toolbarController.get('footerCountry')
      }
    });

    command.execute();
  },

  didFinishEditing: function(manager){
    manager.send('executeCommand');
    PegasusTemplate.Helpers.addOneTimeObserver( manager, 'currentPath', 'saved', function(){
      Ember.run.scheduleOnce( 'afterRender', manager, 'transitionTo', 'idling' );
    });

    manager.send('didSave');
  },

  setup: function( manager, context, types ){
    var toolbarController = PegasusTemplate.lookupController('toolbar');
    this._super.apply(this, arguments);
    this.set('unexecuteSettings', {
      isFooterEmailPreferencesEnabled: toolbarController.get('isFooterEmailPreferencesEnabled'),
      isFooterLogoEnabled: toolbarController.get('isFooterLogoEnabled'),
      footerLabelOpen: $('#unsubscribe_open').text(),
      footerLabelJoin: $('#unsubscribe_join').text(),
      footerLabelClose: $('#unsubscribe_close').text(),
      footerLabelColor: toolbarController.get('footerLabelColor'),
      footerLabelSize: toolbarController.get('footerLabelSize'),
      footerLabelAlignment: toolbarController.get('footerLabelAlignment'),
      footerLabelBold: toolbarController.get('footerLabelBold'),
      footerLabelItalic: toolbarController.get('footerLabelItalic'),
      footerCompany: toolbarController.get('footerCompany'),
      footerStreetAddress: toolbarController.get('footerStreetAddress'),
      footerLocality: toolbarController.get('footerLocality'),
      footerRegion: toolbarController.get('footerRegion'),
      footerPostalCode: toolbarController.get('footerPostalCode'),
      footerPhone: toolbarController.get('footerPhone'),
      footerCountry: toolbarController.get('footerCountry')
    });

    var block = context,
      payload = block.get('payload'),
      controller = PegasusTemplate.lookupController('editing');

    controller.setProperties({
      content: payload,
      edited: context
    });

    Em.run.sync();
    PegasusTemplate.lookupController('frameCommManager').send('editBlock', context.get('toolbarProperties') );
  },
  hover: function(manager, context){
    if ( PegasusTemplate.lookupController('editing').get('edited') !== context.view ){
      PegasusTemplate.lookupController('blockOperations').set('content', context.view);
    } else {
      // the ordering is important here
      PegasusTemplate.lookupController('blockOperations').set('content', null );
      PegasusTemplate.lookupController('rowOperations').set('content', context.view.get('row') );
    }
  },

  edit: function(manager, context){
    var entryValue,
      entryIndex,
      newRow,
      newRowIndex,
      blockCount = context.get('row.blocks.length'),
      type = context.get('payload.type').camelize(),
      transitionedCallback = function(){
        manager.transitionTo('editing.' + type, context );
      };

    if ( context.get('row') ) {
      entryValue = this.get('entryValue');
      entryIndex = context.get('row.blocks').indexOf( context );
      newRow = context.get('row');
      newRowIndex = PegasusTemplate.blockRegionInstance.indexOf( newRow );
      transitionedCallback = function(){
        var targetRow = PegasusTemplate.blockRegionInstance.objectAt( newRowIndex );
        if ( targetRow.get('blocks.length') === blockCount ) {
          Em.run.scheduleOnce('afterRender', manager, function(){
            this.transitionTo( 'editing.' + type, targetRow.get('blocks').objectAt(entryIndex) );
          });
          return;
        }
        Em.run.next( this, transitionedCallback );
      };
    }

    PegasusTemplate.Helpers.addOneTimeObserver(manager, 'currentPath', 'saved', transitionedCallback.bind(this) );

    manager.send('executeCommand');
    manager.send('didSave');
  }
});

PegasusTemplate.EditingViewOnlineState = Em.State.extend({
  isEditing: true,
  unexecuteSettings: {},
  didFinishEditing: function(manager){
    var toolbarController = PegasusTemplate.lookupController('toolbar');

    var command = PegasusTemplate.EditViewOnlineCommand.create({
      unexecuteSettings: this.get('unexecuteSettings'),
      executeSettings: {
        isViewOnlineEnabled: toolbarController.get('isViewOnlineEnabled'),
        viewOnlineLabel: toolbarController.get('viewOnlineLabel'),
        viewOnlineLabelColor: toolbarController.get('viewOnlineLabelColor'),
        viewOnlineLabelSize: toolbarController.get('viewOnlineLabelSize'),
        viewOnlineLabelAlignment: toolbarController.get('viewOnlineLabelAlignment'),
        viewOnlineLabelBold: toolbarController.get('viewOnlineLabelBold'),
        viewOnlineLabelItalic: toolbarController.get('viewOnlineLabelItalic')
      }
    });

    command.execute();

    PegasusTemplate.Helpers.addOneTimeObserver( manager, 'currentPath', 'saved', function(){
      Ember.run.scheduleOnce( 'afterRender', manager, 'transitionTo', 'idling' );
    });

    manager.send('didSave');
  },

  setup: function( manager, context, types ){
    var toolbarController = PegasusTemplate.lookupController('toolbar');
    this._super.apply(this, arguments);

    this.set('unexecuteSettings', {
      isViewOnlineEnabled: toolbarController.get('isViewOnlineEnabled'),
      viewOnlineLabel: toolbarController.get('viewOnlineLabel'),
      viewOnlineLabelColor: toolbarController.get('viewOnlineLabelColor'),
      viewOnlineLabelAlignment: toolbarController.get('viewOnlineLabelAlignment'),
      viewOnlineLabelSize: toolbarController.get('viewOnlineLabelSize'),
      viewOnlineLabelBold: toolbarController.get('viewOnlineLabelBold'),
      viewOnlineLabelItalic: toolbarController.get('viewOnlineLabelItalic')
    });

    if ( !context.get('isUserVisible') ) {
      context.set('payload.dataIsDisplayed', 'true');
      // Trigger change to show/hide hidden
      $(window).trigger('didToggleImageDisplayMode');
    }

    var block = context,
      payload = block.get('payload'),
      controller = PegasusTemplate.lookupController('editing');

    controller.setProperties({
      content: payload,
      edited: context
    });

    Em.run.sync();
    PegasusTemplate.lookupController('frameCommManager').send('editBlock', context.get('toolbarProperties') );
  },

  hover: function(manager, context){
    if ( PegasusTemplate.lookupController('editing').get('edited') !== context.view ){
      PegasusTemplate.lookupController('blockOperations').set('content', context.view);
    } else {
      // the ordering is important here
      PegasusTemplate.lookupController('blockOperations').set('content', null );
      PegasusTemplate.lookupController('rowOperations').set('content', context.view.get('row') );
    }
  },

  edit: function(manager, context){
    var entryValue,
      entryIndex,
      newRow,
      newRowIndex,
      blockCount = context.get('row.blocks.length'),
      type = context.get('payload.type').camelize(),
      transitionedCallback = function(){
        manager.transitionTo('editing.' + type, context );
      };

    if ( context.get('row') ) {
      entryValue = this.get('entryValue');
      entryIndex = context.get('row.blocks').indexOf( context );
      newRow = context.get('row');
      newRowIndex = PegasusTemplate.blockRegionInstance.indexOf( newRow );
      transitionedCallback = function(){
        var targetRow = PegasusTemplate.blockRegionInstance.objectAt( newRowIndex );
        if ( targetRow.get('blocks.length') === blockCount ) {
          Em.run.scheduleOnce('afterRender', manager, function(){
            this.transitionTo( 'editing.' + type, targetRow.get('blocks').objectAt(entryIndex) );
          });
          return;
        }
        Em.run.next( this, transitionedCallback );
      };
    }

    PegasusTemplate.Helpers.addOneTimeObserver(manager, 'currentPath', 'saved', transitionedCallback.bind(this) );

    manager.send('didSave');
  }
});

PegasusTemplate.EditingButtonState = PegasusTemplate.EditingSubState.extend({
});

PegasusTemplate.EditingPreferencesButtonState = PegasusTemplate.EditingSubState.extend({
});


PegasusTemplate.EditingWebTemplateWidgetState = PegasusTemplate.EditingSubState.extend({
});

PegasusTemplate.EditingCaptureTemplateWidgetState = PegasusTemplate.EditingSubState.extend({
});


PegasusTemplate.EditingDividerState = PegasusTemplate.EditingSubState.extend({
});

PegasusTemplate.EditingSocialFollowState = PegasusTemplate.EditingSubState.extend({
  exit: function(){
    PegasusTemplate.lookupController('toolbar').setProperties({
      activeField: null
    });
  }
});

PegasusTemplate.EditingImageState = PegasusTemplate.EditingSubState.extend({
  entryValue: null,
  editedBlockIndex: null,
  setup: function(manager,context){
    this._super.apply( this, arguments );
  }
});

PegasusTemplate.EditingBackgroundImageState = PegasusTemplate.EditingImageState.extend({
  setup: function(){
    this._super.apply(this, arguments);
  }
});

PegasusTemplate.EditingBlockRegionImageState = PegasusTemplate.EditingImageState.extend({
  setup: function(manager,context){
    this._super.apply( this, arguments );
    this.set('originalColor', PegasusTemplate.lookupController('toolbar').get('selectedBlockRegionColor'));
    this.set('originalStyle', PegasusTemplate.lookupController('toolbar').get('selectedBlockRegionImageCovers'));
    this.set('originalImage', PegasusTemplate.lookupController('upload').get('originalDataSrc') );
  },
  didSave: function(manager){
    var uploadController = PegasusTemplate.lookupController('upload');

    var command = PegasusTemplate.EditBlockRegionImageCommand.create({
      unexecuteColor: this.get('originalColor'),
      executeColor: this.get('originalColor'),
      unexecuteImage: this.get('originalImage'),
      executeImage: uploadController.get('dataSrc'),
      unexecuteStyle: this.get('originalStyle'),
      executeStyle: PegasusTemplate.lookupController('toolbar').get('selectedBlockRegionImageCovers')
    });

    command.execute();

    manager.send('didSaveFragment');
  }
});

PegasusTemplate.EditingBodyImageState = PegasusTemplate.EditingImageState.extend({
  setup: function(manager,context){
    this._super.apply( this, arguments );
    this.set('originalColor', PegasusTemplate.lookupController('toolbar').get('selectedBackgroundColor'));
    this.set('originalStyle', PegasusTemplate.lookupController('toolbar').get('selectedBackgroundImageCovers'));
    this.set('originalImage', PegasusTemplate.lookupController('upload').get('originalDataSrc') );
  },
  didSave: function(manager){
    var uploadController = PegasusTemplate.lookupController('upload');

    var command = PegasusTemplate.EditBodyImageCommand.create({
      unexecuteColor: this.get('originalColor'),
      executeColor: this.get('originalColor'),
      unexecuteImage: this.get('originalImage'),
      executeImage: uploadController.get('dataSrc'),
      unexecuteStyle: this.get('originalStyle'),
      executeStyle: PegasusTemplate.lookupController('toolbar').get('selectedBackgroundImageCovers')
    });

    command.execute();

    manager.send('didSaveFragment');
  }
});


PegasusTemplate.EditingTextState = PegasusTemplate.EditingSubState.extend({
  entryValue: null,
  editedBlockIndex: null,

  setup: function(manager,context){
    this._super.apply( this, arguments );
    PegasusTemplate.lookupController('toolbar').set('touched', true);
  }
});

PegasusTemplate.EditingVerticalStaticSpaceState = PegasusTemplate.EditingSubState.extend();

PegasusTemplate.EditingHorizontalStaticSpaceState = PegasusTemplate.EditingSubState.extend();

PegasusTemplate.EditingWebTemplateFormState = PegasusTemplate.EditingSubState.extend();

PegasusTemplate.EditingCaptureTemplateFormState = PegasusTemplate.EditingSubState.extend();

PegasusTemplate.EditingState = PegasusTemplate.BaseState.extend({
  isEditing: true,
  gotoIdle: function( manager, context ) {
    // an editing substate that is exactly as the top level is defined.
    // This allows us to remain in edit while hovering other prospective blocks
    manager.send('hover', context );
  },
  deleteBlock: function(manager){
    var block = PegasusTemplate.lookupController('blockOperations').get('content'),
      backup = block.get('row').mutateForOut(null, true).editor_cookie;

    PegasusTemplate.lookupController('blockOperations').set('content', null);

    block.get('parentView').removeChild(block);
    block.destroy();

    var command = PegasusTemplate.DeleteBlockCommand.create({
      klass: block.get('row').constructor,
      backup: backup,
      sourceElement: block.get('row').mutateForOut(null, true).editor_cookie,
      parent: PegasusTemplate.blockRegionInstance,
      childPosition: block.get('row.parentView').indexOf( block.get('row') ),
      callback: function(){
        PegasusTemplate.stateMachine.transitionTo('idling');
      }
    });

    command.execute();
  },

  enter: function(manager){
    this._super(manager);
    PegasusTemplate.lookupController('blockOperations').set('content', null);
    PegasusTemplate.lookupController('rowOperations').set('content', null);
  },

  exit: function( manager ){
    var controller = PegasusTemplate.lookupController('editing');
    controller.setProperties({
      content: null,
      edited: null
    });
  },

  changePalette: function(manager){
    manager.transitionTo('idling');
    manager.send('changePalette');
  },

  didValidDrop: function(manager){
    manager.transitionTo('idling');
  },

  didSave: function(manager){
    manager.transitionTo('saved');
  },

  verticalStaticSpace: PegasusTemplate.EditingVerticalStaticSpaceState,
  horizontalStaticSpace: PegasusTemplate.EditingHorizontalStaticSpaceState,
  footer: PegasusTemplate.EditingFooterState,
  button: PegasusTemplate.EditingButtonState,
  preferencesButton: PegasusTemplate.EditingPreferencesButtonState,
  text: PegasusTemplate.EditingTextState,
  viewOnline: PegasusTemplate.EditingViewOnlineState,
  bodyImage: PegasusTemplate.EditingBodyImageState,
  backgroundImage: PegasusTemplate.EditingBackgroundImageState,
  image: PegasusTemplate.EditingImageState,
  socialShare: PegasusTemplate.EditingSocialShareState,
  socialFollow: PegasusTemplate.EditingSocialFollowState,
  divider: PegasusTemplate.EditingDividerState,

  palette: PegasusTemplate.EditingPaletteState,

  capturePalette: PegasusTemplate.EditingCapturePaletteState,
  captureTemplateFooter: PegasusTemplate.EditingCaptureTemplateFooterState,
  captureTemplateButton: PegasusTemplate.EditingButtonState,
  captureTemplateBodyImage: PegasusTemplate.EditingBodyImageState,
  captureTemplateBlockRegionImage: PegasusTemplate.EditingBlockRegionImageState,
  captureTemplateForm: PegasusTemplate.EditingCaptureTemplateFormState,
  captureTemplateImage: PegasusTemplate.EditingImageState,
  captureTemplateText: PegasusTemplate.EditingTextState,
  captureTemplateWidget: PegasusTemplate.EditingCaptureTemplateWidgetState,

  webTemplateFooter: PegasusTemplate.EditingWebTemplateFooterState,
  webTemplateButton: PegasusTemplate.EditingButtonState,
  webTemplateBodyImage: PegasusTemplate.EditingBodyImageState,
  webTemplateForm: PegasusTemplate.EditingWebTemplateFormState,
  webTemplateImage: PegasusTemplate.EditingImageState,
  webTemplateText: PegasusTemplate.EditingTextState,
  webTemplateWidget: PegasusTemplate.EditingWebTemplateWidgetState
});
